/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';

import './style.sass';

const Footer = (props) => {
  const {
    column1,
    column2,
    column3,
    column4,
    company,
  } = props.footerData;
  const externalSitesUrls = props.footerData.external_sites_urls;
  const popularCitiesLinks = column3.popular_cities_links.links;

  return (
    <div className="footer" id="js-footer">
      <div className="container">
        <div className="row">
          <div className="footer__col col-sm-3">
            <h3 className="bold">{column1.heading}</h3>
            <p>{column1.text}</p>
            <a href={column1.read_more_link.uri}>{column1.read_more_link.text}</a>
            <div className="social-icons">
              <a href="https://www.facebook.com/MatchOffice" title="Follow us on Facebook" target="_blank" rel="noopener noreferrer" className="social-icon facebook">&nbsp;</a>
              <a href="https://twitter.com/matchoffice?lang=da" title="Share on Twitter" target="_blank" rel="noopener noreferrer" className="social-icon twitter">&nbsp;</a>
              <a href="https://www.linkedin.com/company/matchoffice-aps" title="Follow us on LinkedIn" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">&nbsp;</a>
            </div>
          </div>
          <div className="footer__col col-sm-3">
            <h3 className="bold">{column2.heading}</h3>
            <ul>
              {column2.info_links.map(link => (<li key={link.name}><a href={link.uri}>{link.name}</a></li>))}
            </ul>
          </div>
          <div className="footer__col col-sm-3">
            <h3 className="bold">{column3.heading}</h3>
            {column3.popular_cities_links.visible && (
              <ul>
                {popularCitiesLinks.map(link => (<li key={link.name}><a href={link.uri}>{link.name}</a></li>))}
              </ul>
            )}
            {column3.recommended_bussiness_centers.visible && (
              <div>
                <i>{column3.recommended_bussiness_centers.text}</i>
                <p className="tar">{column3.recommended_bussiness_centers.author}</p>
              </div>
            )}

          </div>
          <div className="footer__col col-sm-3">
            <h3 className="bold">{column4.heading}</h3>
            <i>{column4.text}</i>
            <p className="tar">{column4.author}</p>
          </div>
        </div>
        <div className="footer__bottom">
          <span itemScope="itemscope" itemType="http://data-vocabulary.org/Organization">
            <span itemProp="name">
              {company.name}
              &nbsp; • &nbsp;
            </span>
            <span itemProp="address" itemScope="itemscope" itemType="http://data-vocabulary.org/Address">
              <span itemProp="street-address">
                {company.address}
                &nbsp; • &nbsp;
              </span>
              <span itemProp="postal-code">
                {company.postal_code}
                &nbsp;
              </span>
              <span itemProp="locality">
                {company.city}
                  &nbsp; • &nbsp;
              </span>
            </span>
            {company.phone && (
              <a href={`tel:${company.phone}`} itemProp="tel" className="no-underline">
                {company.phone}
                &nbsp; • &nbsp;
              </a>
            )}
            <span className="richMail">
              <a href={`mailto:${company.email}`}>{company.email}</a>
            </span>
          </span>
          {externalSitesUrls.map(externalLink => (
            <a
              className="global-site-link"
              href={externalLink.url}
              key={externalLink.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {externalLink.text}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  footerData: PropTypes.oneOfType([PropTypes.object]),
};

Footer.defaultProps = {
  footerData: {},
};

export default Footer;
